





























































































































































































































































import { isEmptyObject } from '@/utils/helpers';
import props from './common/props';

import { Sponsor } from '@/models/sponsor';
import { FormRules } from '@/mixins/FormRules';
import { cloneDeep, isObject, transform, isEqual } from 'lodash';
import { mapState } from 'vuex';

import Vue from 'vue';

export default Vue.extend({
  name: 'DataSponsorEditCard',
  mixins: [FormRules],
  props: {
    ...props.base,
    categories: props.detail.categories,
    options: props.detail.options,
    sponsor: props.detail.sponsor,
    save: props.functions.save
  },
  data: () => ({
    show: false,
    optionsLoading: false,
    updateSponsor: {} as Sponsor,
    mutableSponsor: {} as Sponsor,
    itemsAdded: 0 as number,
    itemImage: null as any,
    cacheImage: null as string | null | File,
    rightDrawer: false
  }),
  computed: {
    ...mapState({
      sponsorError: (state: any) => state.sponsors.error
    })
  },
  methods: {
    isEmptyObject,
    difference(object: any, base: any) {
      function changes(object: any, base: any) {
        return transform(object, function(result: any, value: any, key: any) {
          if (!isEqual(value, base[key])) {
            result[key] =
              isObject(value) && isObject(base[key])
                ? changes(value, base[key])
                : value;
          }
        });
      }
      return changes(object, base);
    },
    onChange(e: any): void {
      try {
        const reader = new FileReader();
        const files = e.target.files || e.dataTransfer.files;
        this.itemsAdded = files.length;
        reader.onload = (e: ProgressEvent<FileReader>) => {
          this.itemImage = e.target?.result;
        };
        reader.readAsDataURL(files[0]);
        this.cacheImage = files[0];
      } catch (e) {
        console.log(e);
      }
    }
  },
  watch: {
    mutableSponsor: {
      handler(val: Sponsor) {
        this.updateSponsor = this.difference(val, this.sponsor);
        this.updateSponsor.id = this.sponsor.id;
        this.updateSponsor.name
          ? (this.updateSponsor.name = this.sponsor.name)
          : null;
        this.cacheImage ? (this.updateSponsor.logo = this.cacheImage) : null;
        console.log({ ...this.updateSponsor });
      },
      deep: true
    },
    cacheImage: {
      handler(val) {
        console.log(val);
        this.cacheImage ? (this.updateSponsor.logo = val) : null;
      }
    }
  },
  created() {
    if (this.sponsor) {
      console.log(this.sponsor);

      this.mutableSponsor = cloneDeep(this.sponsor);
      console.log({ ...this.mutableSponsor });
    }
  }
});
